module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/vi/2-fe94fc70602436b92221ae6b73a0ae06.jpg";